<template>
	<div>
		<div v-if="!composant">
			<h1>Extraction de documents</h1>

			<b-form inline>
				<b-input-group prepend="Nom">
					<b-form-input v-model="name"></b-form-input>
				</b-input-group>
				<b-input-group prepend="Version">
					<b-form-input v-model="version"></b-form-input>
				</b-input-group>
				<b-button v-b-modal="'modal' + id">Charger</b-button>
				<b-button @click="save_db" :disabled="!version || !name"
					><i class="fas fa-save"></i
				></b-button>
				<b-button v-b-modal="'modal_file' + id">Fichier</b-button>
				<b-button v-b-modal="'modal_rename' + id">Renommer</b-button>
			</b-form>

			<b-modal :hide-footer="true" :id="'modal' + id" title="Charger">
				<span>Nom</span>
				<v-select
					v-model="load_name"
					:options="names"></v-select>
				<span>Version</span>
				<v-select
					v-model="load_version"
					:options="versions"></v-select>
			</b-modal>

			<b-modal
				:hide-footer="true"
				:id="'modal_file' + id"
				title="Fichier">
				<b-file
					accept=".json"
					@change="load_file"
					placeholder="charger (fichier)"></b-file>
				<br /><br />
				<b-button @click="save">sauvergarder (fichier)</b-button>
			</b-modal>

			<b-modal
				:hide-footer="true"
				:id="'modal_rename' + id"
				title="Renommer">
				<p>Nouveau nom</p>
				<b-input v-model="new_name"></b-input>
				<br />
				<b-button @click="rename">Rennomer</b-button>
			</b-modal>

			<br />
		</div>

		<b-tabs>
			<b-tab title="Chargement">
				<br />
				<files-upload
					:name="false"
					@update="importFile"
					ref="upload"></files-upload>
				<b-button @click="start()" class="my-3" :disabled="files.length == 0">Analyser</b-button
				>&nbsp;
				<div v-if="counter > 0 && counter < 100">
					Chargement des fichiers en cours
					<b-progress :value="counter" animated></b-progress>
				</div>
				<div v-if="spinner" class="center_spinner">
					<fade-loader></fade-loader>
				</div>
				<div v-show="documents_array.length > 0">
					<b-table
						striped
						hover
						:items="documents_array"
						:fields="fields">
						<template v-slot:cell(download)="data">
							<b-button
								@click="
									viewFile(data.item.url_pdf, data.item.name)
								"
								><i class="fas fa-eye"></i
							></b-button>
							&nbsp;
							<b-button @click="deleteFile(data.item.id_name)"
								><i class="fas fa-trash"></i
							></b-button>
						</template>
					</b-table>
					<viewFile ref="view_file"></viewFile>
				</div>
				<div v-if="table">
					<hr />
					<p>Sélectionner un fichier</p>
					<b-select :options="table_options" v-model="table_select"></b-select>
					<b-button variant="link" @click="add_db_file"><i class="fa fa-plus"></i></b-button>
					<div v-show="table_files.length > 0">
						<b-table
							striped
							hover
							:items="table_files"
							:fields="table_fields">
							<template v-slot:cell(download)="data">
								<b-button @click="delete_db_file(data.item.id)"
									><i class="fas fa-trash"></i
								></b-button>
							</template>
						</b-table>
					</div>
				</div>
			</b-tab>
			<b-tab title="Configuration">
				<div>
					<span>Colonne de nom de page</span>
					<b-input v-model="column_name"></b-input>
				</div>
				<div>
					<span>OCR</span>
					<b-form-select
						v-model="ocr"
						:options="['Interne', 'Abbyy', 'Google Vision']"
						@change="updateOcr"></b-form-select>
				</div>
				<div>
					<span>OCR - si le texte dans le pdf avant ocr fait moins de X caractères fois le nombre de pages</span>
					<b-input
						type="number"
						v-model="ocr_nb"
						@change="updateOcrParams"></b-input>
				</div>
				<div>
					<span>Alignement des zones de textes en pixel</span>
					<b-input type="number" v-model="align" @change="updateAlign"></b-input>
				</div>
				<div>
					<span>Données sur plusieurs pages</span>
					<b-checkbox v-model="inter_page" @change="updateFinalExtract"></b-checkbox>
				</div>
				<div>
					<span>Colonne du nom du fichier</span>
					<b-input v-model="column_file" @change="update()"></b-input>
				</div>
				<div>
					<span>Rotation à 90°</span>
					<b-checkbox v-model="rotate_90" @change="updateAlign"></b-checkbox>
				</div>
				<div>
					<span>Rotation à 180°</span>
					<b-checkbox v-model="rotate_180" @change="updateAlign"></b-checkbox>
				</div>
				<div>
					<span>Rotation à 270°</span>
					<b-checkbox v-model="rotate_270" @change="updateAlign"></b-checkbox>
				</div>
				<div>
					<span>Pré traitement</span>
					<document_extraction_post_treatment 
						:ref="'document_extraction_pre_treatment'"
						:projects="list_projects"
						:projects_options="projects_options"
						:scenario="$refs.scenario"
						:pre_treatment="true"
					></document_extraction_post_treatment>
				</div>
			</b-tab>
			<b-tab title="Extraction">
				<br />
				<document_extraction_page
					v-if="init"
					ref="extract_page"
					@update="update"
					:projects="list_projects"
					:projects_options="projects_options"
					:scenario="$refs.scenario"
					:column_name="column_name"
					:document_extraction="document_extraction"
					:document_extraction_type="document_extraction_type"
					:inter_page="inter_page"></document_extraction_page>
			</b-tab>
			<b-tab v-if="!composant" title="Scénario">
				<br />
				<project
					ref="scenario"
					initial_method_prop="fichiers"
					:config="false"
					state_prop="etape"></project>
			</b-tab>
		</b-tabs>
	</div>
</template>

<script>
	import pdf from "vue-pdf";
	import draggable from "vuedraggable";
	import uniqueId from "lodash.uniqueid";
	import { JSONEditor } from "@json-editor/json-editor";
	import FadeLoader from "vue-spinner/src/FadeLoader.vue";

	import store from "../store";
	import project from "./Project.vue";
	import users from "../services/users.js";
	import utils from "../services/utils.js";
	import workers from "../services/workers.js";
	import element from "../services/element.js";
	import database from "../services/database.js";
	import projects from "../services/projects.js";
	import databaseView from "../views/database.vue";
	import viewFile from "../components/viewFile.vue";
	import treatments from "../services/treatments.js";
	import document_service from "../services/document.js";
	import file_upload from "../components/file_upload.vue";
	import edit_tabulator from "../components/edit_tabulator.vue";
	import document_template_type from "../components/document_template_type.vue";
	import document_extraction_page from "../components/document_extraction_page.vue";
	import document_extraction_post_treatment from "../components/document_extraction_post_treatment.vue";

	import "../../public/js/ace-builds/src-min-noconflict/ace.js";

	var clone = require("clone");

	export default {
		name: "document_extraction",
		components: {
			pdf,
			project,
			viewFile,
			draggable,
			FadeLoader,
			edit_tabulator,
			document_template_type,
			document_extraction_page,
			"files-upload": file_upload,
			databaseView,
			document_extraction_post_treatment
		},
		props: ["composant"],
		data() {
			return {
				align: "",

				init: false,
				list_projects: [],
				projects_options: [],

				ocr: "Interne",
				column_name: "",
				type: "document_extraction",
				name: "",
				new_name: name,
				names: [],
				versions: [],
				version: "",
				load_name: "",
				load_version: "",
				id: uniqueId(),
				files: [],
				results: {},
				values: "",
				items: [],
				documents: {},
				documents_array: [],
				spinner: false,
				fields: [
					{
						key: "name",
						label: "Fichier",
					},
					{
						key: "download",
						label: "Actions",
					},
				],

				document_extraction: [],
				document_extraction_type: {},
				counter: 0,
				table: "",
				table_document: "",
				table_select: "",
				table_options: [],
				table_files: [],
				table_lines: [],
				table_fields: [
					{
						key: "name",
						label: "Fichier",
					},
					{
						key: "align",
						label: "Alignement",
					},
					{
						key: "download",
						label: "Actions",
					},
				],
				inter_page: false,
				ocr_nb: 10,
				column_file: "",
				data: {},
				rotate_90: false,
				rotate_180: false,
				rotate_270: false
			};
		},
		watch: {
			index: {
				async handler() {},
			},
			column_name: {
				async handler() {
					if (!this.composant)
						this.$refs.scenario.updateStepParametersByDescription(
							"Analyse pdf - étape 3",
							{ column_name: this.column_name }
						);
				},
			},
			type: {
				async handler() {
					this.set_name();
				},
			},
			load_name: {
				async handler() {
					var elements = await element.getby_libelle(
						this.load_name,
						this.type
					);
					elements = elements.element;

					this.versions = [];
					for (var i = 0; i < elements.length; i++) {
						if (i == 0) {
							if (
								this.load_version &&
								this.load_version == elements[i].version
							)
								await this.load_db();
							this.load_version = elements[i].version;
						}
						this.versions.push(elements[i].version);
					}
				},
			},
			load_version: {
				async handler() {
					if (this.load_version) await this.load_db();
				},
			},
		},
		methods: {
			update: async function (data = null) {
				if (!data)
					data = this.data;
				else
					this.data = data;
				if (!this.composant)
					this.$refs.scenario.updateStepParametersByDescription(
						"Analyse pdf - étape 2",
						{ column_file: this.column_file, zones: data }
					);
			},
			viewFile: async function (url, name) {
				this.$refs.view_file.viewFile(url, name, {});
			},
			deleteFile: async function (name) {
				delete this.documents[name];

				this.documents_array = [];
				var keys = Object.keys(this.documents);
				for (var i = 0; i < keys.length; i++) {
					this.documents_array.push({
						url_pdf: this.documents[keys[i]].url_pdf,
						id_name: keys[i],
						name: keys[i] + ".pdf",
					});
				}
				this.$refs.extract_page.setDocuments(this.documents);
			},
			async rename() {
				await element.rename(this.type, this.name, this.new_name);
				this.name = this.new_name;
				this.save_db();
			},
			async updateAlign()
			{
				await this.$refs.scenario.updateStepParametersByDescription(
					"Analyse pdf - étape 1",
					{ align: this.align ? parseInt(this.align) : true, 
					rotate_90: this.rotate_90 || false,
					rotate_180: this.rotate_180 || false,
					rotate_270: this.rotate_270 || false }
				);
			},
			async updateOcrParams()
			{
				if (typeof this.ocr_nb == "string")
				{
					this.ocr_nb = parseInt(this.ocr_nb);
				}
				await this.$refs.scenario.updateStepParametersByDescription(
					"ocr",
					{ check: this.ocr_nb }
				);
			},
			async updateFinalExtract()
			{
				await this.$refs.scenario.updateStepParametersByDescription(
					"Analyse pdf - étape 3",
					{ inter_page: this.inter_page }
				);
			},
			async updateOcr(value) {
				this.ocr = value;

				if (!this.composant) {
					if (this.ocr == "Abbyy") {
						await this.$refs.scenario.updateStepActionByDescription(
							"ocr",
							"abbyy",
							"Abbyy"
						);
					} else if (this.ocr == "Google Vision") {
						await this.$refs.scenario.updateStepActionByDescription(
							"ocr",
							"vision",
							"Ocr - Google Vision"
						);
					} else {
						await this.$refs.scenario.updateStepActionByDescription(
							"ocr",
							"ocr",
							"Ocr"
						);
					}
				}
			},
			async set_name() {
				var names = await element.getby_production(this.type);
				names = names.element;

				this.names = [];
				for (var i = 0; i < names.length; i++) {
					this.names.push(names[i].libelle);
				}
			},
			async save_db() {
				var data = {
					ocr: this.ocr,
					name: this.name,
					column_name: this.column_name,
					documents: this.documents,
					documents_array: this.documents_array,
					extract_page: await this.$refs.extract_page.save(),
					table_files: this.table_files,
					inter_page: this.inter_page,
					ocr_nb: this.ocr_nb,
					column_file: this.column_file,
					rotate_90: this.rotate_90,
					rotate_180: this.rotate_180,
					rotate_270: this.rotate_270,
					pre_treatment: await this.$refs.document_extraction_pre_treatment.save()
				};

				this.$refs.scenario.update_name(this.name);
				this.$refs.scenario.set_version(this.version);
				//data.scenario = await this.$refs.scenario.save(false);
				await this.$refs.scenario.save_db(false, false);

				console.log("save")
				console.log(data)

				await element.save(this.name, this.version, data, this.type);
				await this.set_name();
			},
			async save(file = true) {
				var data = {
					ocr: this.ocr,
					name: this.name,
					column_name: this.column_name,
					documents: this.documents,
					documents_array: this.documents_array,
					extract_page: await this.$refs.extract_page.save(),
					table_files: this.table_files,
					inter_page: this.inter_page,
					ocr_nb: this.ocr_nb,
					column_file: this.column_file,
					rotate_90: this.rotate_90,
					rotate_180: this.rotate_180,
					rotate_270: this.rotate_270,
					pre_treatment: await this.$refs.document_extraction_pre_treatment.save()
				};

				if (!this.composant) {
					this.$refs.scenario.update_name(this.name);
					this.$refs.scenario.update_version(this.version);
					data.scenario = await this.$refs.scenario.save(false);
				}

				if (file)
					utils.saveToFile(
						JSON.stringify(data),
						(this.name ? this.name : "document_extraction") +
							".json"
					);
				else 
				{
					return data;
				}
			},
			async load(data) {
				var self = this;

				console.log("load")
				console.log(clone(data))

				this.pages = [];

				this.ocr = data.ocr || "Interne";
				this.name = data.name;
				this.documents = data.documents;
				this.documents_array = data.documents_array || [];
				this.column_name = data.column_name || "";
				this.table_files = data.table_files || [];
				this.inter_page = data.inter_page || false;
				if (data.ocr_nb != 0 && !data.ocr_nb)
					data.ocr_nb = 10;
				this.ocr_nb = data.ocr_nb;
				this.column_file = data.column_file || "";

				this.rotate_90 = data.rotate_90 || false;
				this.rotate_180 = data.rotate_180 || false;
				this.rotate_270 = data.rotate_270 || false;

				await this.$refs.extract_page.load(data.extract_page);
				this.$refs.extract_page.setDocuments(this.documents);

				if (data.pre_treatment)
					await this.$refs.document_extraction_pre_treatment.load(data.pre_treatment);

				self.$nextTick(async function () {
					if (!self.composant) {
						if (data.scenario)
							await self.$refs.scenario.load(data.scenario);
						else
							await self.$refs.scenario.load_db(
								self.name,
								self.version
							);
					}
				});
			},
			async load_db() {
				document.body.style.cursor = "wait";
				var result = await element.load(
					this.load_name,
					this.load_version,
					this.type
				);
				this.name = this.load_name;
				this.version = this.load_version;
				await this.load(result);
				this.$refs.extract_page.setDocuments(this.documents);

				document.body.style.cursor = "default";
			},
			async load_file(event) {
				var self = this;

				var file = "";
				if (event.dataTransfer) file = event.dataTransfer.files[0];
				else file = event.target.files[0];

				var reader = new FileReader();

				reader.onload = (function (theFile) {
					return function (e) {
						var data = JSON.parse(e.target.result);
						self.load(data);
					};
				})(file);

				reader.readAsText(file);
			},
			set_progress(totaluploadprogress) {
				console.log("set_progress : " + totaluploadprogress);
				this.counter = totaluploadprogress;
			},
			get_project(uid) {

				// console.log(this.project_id)
				for (var i = 0; i < this.list_projects.length; i++) {
					if (this.list_projects[i].uid == uid) {
						return this.list_projects[i];
					}
				}
			},
			async test_project(
				project,
				formData,
				tags,
				results_files,
				name_file,
				first_csv,
				urls,
				nb_step, 
				step,
				params,
				treatment_params,
				step_uid
			) {
				var results = []
				var tag_data = {};
				if (project.tags && tags) {
					for (var i = 0; i < project.tags.length; i++) {
						if (project.tags[i].tag == tags)
							tag_data = project.tags[i];
					}
				}
				var treatment_data = await treatments.create(
					project.uid,
					null,
					null,
					null,
					[tags],
					tag_data.type_import || "import",
					formData,
					params,
					treatment_params,
					step_uid
				);
				while (
					treatment_data.treatment.resultat != "ok" &&
					treatment_data.treatment.resultat != "ko"
				) {
					await new Promise((resolve) => setTimeout(resolve, 2000));
					treatment_data = await treatments.get(
						treatment_data.treatment.uid
					);
				}
				var all_files = await treatments.getFiles(
					treatment_data.treatment.uid
				);
				if (!all_files || all_files.length == 0) all_files = [];
				all_files.sort((a, b) =>
					a.nom_fichier > b.nom_fichier ? 1 : -1
				);
				var export_type = tag_data.type_export || "export";
				for (var i = 0; i < all_files.length; i++) {
					if (nb_step <= 1) {
						if (
							first_csv &&
							all_files[i].type == export_type &&
							all_files[i].nom_fichier.endsWith(".csv") &&
							!step.file_result
						) {
							var csv_data = await treatments.getFile(
								all_files[i].uid,
								all_files[i].nom_fichier,
								false,
								false
							);
							name_file = all_files[i].nom_fichier;
							results = this.$papa.parse(csv_data, {
								header: true,
							});
							results = results.data;
							first_csv = false;
						} else if (all_files[i].type == export_type) {
							urls.push({
								url: all_files[i].url,
								name: all_files[i].nom_fichier,
							});
						}
					} else {
						if (all_files[i].type == export_type)
							urls.push({
								url: all_files[i].url,
								name: all_files[i].nom_fichier,
							});
					}
				}

				return { name_file, first_csv, urls, results };
			},
			async start() {
				this.counter = 0;
				this.spinner = true;

				var steps = await this.$refs.scenario.getStepsByDescription("Pre treatment");
				this.post_treatment_logs = [];

				var results = []

				console.log(steps)

				for (var i = 0; i < steps.length; i++)
				{
					console.log(steps[i]);

					let formData = new FormData();
					//console.log(await this.$refs.edit_tabulator_post_t.get_data())
					for (var j = 0; j < this.files.length; j++) {
						formData.append(this.files[j].name, this.files[j]);
					}

					let project = this.get_project(steps[i].data.parameters.project);
					let resp = await this.test_project(
						project,
						formData,
						steps[i].data.parameters.tags,
						[],
						"",
						true,
						[],
						0,
						{},
						steps[i].data.parameters,
						[],
						uniqueId()
					);

					console.log(resp)

					results = resp.urls;

					console.log(results)

					this.files = [];
					for (var j = 0; j < results.length; j++) {
						var blob = await treatments.getFileAlyx(
							results[j].url,
							false,
							"arraybuffer"
						);
						this.files.push(
							new File([blob], results[j].name, {
								type: blob.type,
							})
						);
					}
				}

				if (true /*this.ocr*/) {
					var formData = new FormData();

					var action = "ocr";
					if (this.ocr == "Abbyy") action = "abbyy";
					else if (this.ocr == "Google Vision") action = "vision";

					var data = {
						action: action,
						parameters: {
							check: this.ocr_nb
						},
					};
					Object.keys(data).forEach((key) =>
						formData.set(
							key,
							typeof data[key] === "object"
								? JSON.stringify(data[key])
								: data[key]
						)
					);
					for (var i = 0; i < this.files.length; i++) {
						formData.append(this.files[i].name, this.files[i]);
					}
					this.results = await workers.test(formData, null, this);

					var formData = new FormData();

					var files = [];
					for (var i = 0; i < this.results.data.files.length; i++) {
						var results_file = await treatments.getFileAlyx(
							this.results.data.files[i].url,
							false,
							"arraybuffer"
						);
						var blob = await treatments.getFileAlyx(
							this.results.data.files[i].url,
							false,
							"arraybuffer"
						);
						files.push(
							new File([blob], this.results.data.files[i].name, {
								type: blob.type,
							})
						);
					}
					for (var i = 0; i < files.length; i++) {
						formData.append(files[i].name, files[i]);
					}
				} else {
					var formData = new FormData();

					for (var i = 0; i < this.files.length; i++) {
						formData.append(this.files[i].name, this.files[i]);
					}
				}

				var data = {
					action: "pdf_extract",
					parameters: {
						json: true,
						align: this.align ? parseInt(this.align) : true,
						rotate_90: this.rotate_90,
						rotate_180: this.rotate_180,
						rotate_270: this.rotate_270,
					},
				};

				Object.keys(data).forEach((key) =>
					formData.set(
						key,
						typeof data[key] === "object"
							? JSON.stringify(data[key])
							: data[key]
					)
				);

				this.results = await workers.test(formData);

				console.log(this.results.data.files);

				this.values = {};
				if (this.results.data && this.results.data.json) {
					var keys_files = Object.keys(this.results.data.json);
					for (var i = 0; i < keys_files.length; i++) {
						this.documents[keys_files[i]] =
							this.results.data.json[keys_files[i]];
						var keys_pages = Object.keys(
							this.results.data.json[keys_files[i]].pages
						);
						for (var j = 0; j < keys_pages.length; j++) {
							if (j == 0) {
								this.documents[keys_files[i]].url_pdf = this.results.data.json[keys_files[i]].pages[keys_pages[j]].url_pdf;
								this.$refs.extract_page.setStyle(this.results.data.json[keys_files[i]].styles);
								this.$refs.extract_page.setMeta(keys_pages[j], this.results.data.json[keys_files[i]].pages[keys_pages[j]].current_page, this.results.data.json[keys_files[i]].pages[keys_pages[j]].url_pdf, this.results.data.json[keys_files[i]].pages[keys_pages[j]].rotate);
								this.items = [];
							}
							this.results.data.json[keys_files[i]].pages[keys_pages[j]].url_image = this.documents[keys_files[i]].url_pdf.replace(/[^\/]*$/, "") + keys_files[i];
							if (this.results.data.json[keys_files[i]].pages[keys_pages[j]].rotate)
								this.results.data.json[keys_files[i]].pages[keys_pages[j]].url_image += "_" + this.results.data.json[keys_files[i]].pages[keys_pages[j]].rotate + "_";
							if (this.results.data.json[keys_files[i]].pages[keys_pages[j]].current_page < 10)
								this.results.data.json[keys_files[i]].pages[keys_pages[j]].url_image += "0";
							if (this.results.data.json[keys_files[i]].pages[keys_pages[j]].current_page < 100)
								this.results.data.json[keys_files[i]].pages[keys_pages[j]].url_image += "0";
							this.results.data.json[keys_files[i]].pages[keys_pages[j]].url_image += this.results.data.json[keys_files[i]].pages[keys_pages[j]].current_page + ".png";
						}
					}
				}

				this.values = JSON.stringify(this.values, null, 2);
				this.$refs.upload.del_file();

				this.documents_array = [];
				var keys = Object.keys(this.documents);
				for (var i = 0; i < keys.length; i++) {
					this.documents_array.push({
						url_pdf: this.documents[keys[i]].url_pdf,
						id_name: keys[i],
						name: keys[i] + ".pdf",
					});
				}

				this.$refs.extract_page.setDocuments(this.documents);

				this.spinner = false;
			},
			async add_db_file()
			{
				console.log("add_db_file")
				var file = this.table_lines[this.table_select];
				console.log(file)
				this.table_files.push(file);
				this.table_select = "";

				var json =  await treatments.getFileAlyx(
					file.url,
					false,
					false
				);

				//json = JSON.parse(json);
				
				console.log(json)

				var keys_pages = Object.keys(json.pages);
				for (var i = 0; i < keys_pages.length; i++) {
					if (i == 0) {
						json.url_pdf = "";
						this.$refs.extract_page.setStyle(json.styles);
						this.$refs.extract_page.setMeta(keys_pages[i], json.pages[keys_pages[i]].current_page, "", json.pages[keys_pages[i]].rotate);
						this.items = [];
					}
					console.log("name_image")
					var name_image = file.name;
					console.log(name_image);
					if (json.pages[keys_pages[i]].current_page < 10)
						name_image += "0";
					if (json.pages[keys_pages[i]].current_page < 100)
						name_image += "0";
					name_image += json.pages[keys_pages[i]].current_page + ".png";
					console.log(name_image);
					var url_image = await database.get(
						"SELECT",
						this.table_document,
						{ select: "*", where: 'folder_name = "' + file.folder + '" and libelle = "' + name_image + '"'}
					);

					if (url_image.length > 0)
					{
						json.pages[keys_pages[i]].url_image = url_image[0].url;
					}
					else
						json.pages[keys_pages[i]].url_image = "";
				}

				console.log(json);

				this.documents[file.name] = json;
				this.$refs.extract_page.setDocuments(this.documents);
			},
			delete_db_file(id)
			{
				for (var i = 0; i < this.table_files.length; i++)
				{
					if (this.table_files[i].id == id)
					{
						delete this.documents[this.table_files[i].name];
						this.table_files.splice(i, 1);
						this.$refs.extract_page.setDocuments(this.documents);
						break;
					}
				}
			},
			async importFile() {
				this.files = await this.$refs.upload.get_data_files(false);
			},
		},
		mounted: async function () {

			var self = this;

			if (
				store.state.user.rules &&
				!store.state.user.rules.decument_extraction
			) {
				this.$router.push({ name: "profile" });
			}

			var response = await users.getSelf(true);
			if (response) {
				//console.log("In app, found user setting style");
				var client = response.client;

				if (client.details && client.details.extraction_pdf)
				{
					if (client.details.extraction_pdf.table)
					{
						this.table = client.details.extraction_pdf.table;
						this.table_document = client.details.extraction_pdf.table_document;
						this.table_options = [];

						this.table_lines = await database.get(
							"SELECT",
							this.table,
							{ select: "*"}
						);

						for (var i = 0; i < this.table_lines.length; i++)
						{
							this.table_options.push({text: this.table_lines[i].name, value: i})
						}
					}
				}

				if (client.details && client.details.document_extraction)
				{
					console.log("set document_extraction")
					this.document_extraction = client.details.document_extraction;
					for (var i = 0; i < this.document_extraction.length; i++)
					{
						this.document_extraction[i].value = this.document_extraction[i].type;
					}
					this.document_extraction.unshift({
						text: "",
						value: ""
					})
					this.document_extraction_type = client.details.document_extraction_type;
				}

				var keys = Object.keys(this.document_extraction_type);
				for (var i = 0; i < keys.length; i++)
				{
					console.log(keys[i]);
					if (this.document_extraction_type[keys[i]].type == "image" || this.document_extraction_type[keys[i]].type == "sql")
					{
						var lines = await database.get(
							"SELECT",
							this.document_extraction_type[keys[i]].table,
							{ select: "*", end: this.document_extraction_type[keys[i]].sql }
						);

						console.log(lines)

						this.document_extraction_type[keys[i]].values = [];
						for (var j = 0; j < lines.length; j++)
						{
							var value = {
								text: lines[j][this.document_extraction_type[keys[i]].column_description],
								value: lines[j][this.document_extraction_type[keys[i]].column_value]
							};
							if (this.document_extraction_type[keys[i]].type == "image")
								value.value = value.value.replace(/\..*/g, "");
							this.document_extraction_type[keys[i]].values.push(value);
						}
					}
				}
			}

			this.list_projects = await projects.getAll(false, true);

			for (var i = 0; i < this.list_projects.length; i++) {
				if (this.list_projects[i].archive == true) {
					this.list_projects.splice(i, 1);
					i--;
				}
			}

			for (var i = 0; i < this.list_projects.length; i++) {
				if (
					this.list_projects[i].details &&
					this.list_projects[i].details.column_import
				)
					this.list_projects[i].column_import =
						this.list_projects[i].details.column_import;
				if (
					this.list_projects[i].details &&
					this.list_projects[i].details.tags
				) {
					this.list_projects[i].list_tags = [""];
					this.list_projects[i].tags =
						this.list_projects[i].details.tags;
					for (
						var j = 0;
						j < this.list_projects[i].tags.length;
						j++
					) {
						if (this.list_projects[i].tags[j].scenario)
							this.list_projects[i].list_tags.push(
								this.list_projects[i].tags[j].tag
							);
					}
				}
			}

			for (var i = 0; i < this.list_projects.length; i++) {
				if (this.list_projects[i].details && this.list_projects[i].details.inDropdownPostTreatments)
				{
					this.projects_options.push({
						value: this.list_projects[i]["uid"],
						text: this.list_projects[i]["libelle"],
					});
				}
			}

			this.list_projects.unshift({});
			this.projects_options.unshift({value: "", text: ""});

			this.set_name();

			if (!this.composant) {

				if (client && client.details && client.details.extraction_pdf)
				{
					this.$refs.scenario.set_init_data({
						"fichiers": {
							"active": true,
							"default": false,
							"type": ""
						},
						"documents": {
							"active": true,
							"default": true,
							"folder": client.details.extraction_pdf.folder || "",
							"extension": "json",
							"id_prefix": false
						}
						});
				}

				await this.$refs.scenario.addStep({
					data: {
						action: "ocr",
						label: "ocr",
						parameters: {},
						sql_rules: "",
					},
					description: "ocr",
					action: "ocr",
					c_conditions: false,
					c_tree: false,
					c_project: false,
					project_id: "",
					c_parameters: true,
					c_tabulator: false,
					c_test: true,
					tabulator2: [],
					keep_start_data: false,
					option_delete: false,
					option_make_list: false,
					treatment: false,
				});

				await this.$refs.scenario.addStep({
					data: {
						action: "pdf_extract",
						label: "Analyse pdf - étape 1",
						parameters: {
							align: true
						},
						sql_rules: "",
					},
					description: "Analyse pdf - étape 1",
					action: "pdf_extract",
					c_conditions: false,
					c_tree: false,
					c_project: false,
					project_id: "",
					c_parameters: true,
					c_tabulator: false,
					c_test: true,
					tabulator2: [],
					keep_start_data: false,
					option_delete: false,
					option_make_list: false,
					treatment: false,
				});

				await this.$refs.scenario.addStep({
					data: {
						action: "zone_extract",
						label: "Analyse pdf - étape 2",
						parameters: {
						},
						sql_rules: "",
					},
					description: "Analyse pdf - étape 2",
					action: "zone_extract",
					c_conditions: false,
					c_tree: false,
					c_project: false,
					project_id: "",
					c_parameters: true,
					c_tabulator: false,
					c_test: true,
					tabulator2: [],
					keep_start_data: false,
					option_delete: false,
					option_make_list: false,
					treatment: false,
				});

				await this.$refs.scenario.addStep({
					data: {
						action: "zone_final_extract",
						label: "Analyse pdf - étape 3",
						parameters: {
							column_name: "",
							inter_page: this.inter_page
						},
						sql_rules: "",
					},
					description: "Analyse pdf - étape 3",
					action: "zone_final_extract",
					c_conditions: false,
					c_tree: false,
					c_project: false,
					project_id: "",
					c_parameters: true,
					c_tabulator: false,
					c_test: true,
					tabulator2: [],
					keep_start_data: false,
					option_delete: false,
					option_make_list: false,
					treatment: false,
				});

				self.$nextTick(async function () {
					if (client && client.details && client.details.extraction_pdf)
					{
						if (client.details.extraction_pdf.ocr)
						{
							self.ocr = client.details.extraction_pdf.ocr;
							self.updateOcr(self.ocr);
						}
						if (client.details.extraction_pdf.ocr_nb)
						{
							self.ocr_nb = client.details.extraction_pdf.ocr_nb;
							self.updateOcrParams();
						}
					}
				})
			}

			this.init = true;
		},
	};
</script>
